import * as React from 'react';
import { NavLink } from '..';
import { Text } from 'ilenia';

interface NavBarProps {
    pluginVersion: string;
    source: string;
    disabled: boolean;
    notify: boolean;
    mode?: string;
}

export const NavBar: React.SFC<NavBarProps> = (props) => {
    const defaultNavBar = ({ disabled, notify, source }: NavBarProps) =>
        <div>
            <NavLink to="/general" disabled={disabled}><Text id="general.title"/></NavLink>
            <NavLink to="/invitations" disabled={disabled}><Text id="invitations.title"/></NavLink>
            <NavLink to="/product-reviews" disabled={disabled}><Text id="ProductReviews.title"/></NavLink>
            <NavLink to="/past-orders" disabled={disabled}><Text id="pastOrders.title"/></NavLink>
            <NavLink to="/trustbox" disabled={disabled}><Text id="trustBox.title"/></NavLink>
            {renderFAQ(source, disabled)}
            {renderUpdate(source, disabled, notify)}
            <NavLink to="/settings" disabled={disabled}><Text id="settings.title"/></NavLink>
        </div>;

    const renderFAQ = (source: string, disabled: boolean) =>
        ['bigcommerce', 'shopware'].includes(source.toLowerCase())
            ? null
            : <NavLink to="/faq" disabled={disabled}><Text id="faq.title"/></NavLink>;

    const renderUpdate = (source: string, disabled: boolean, notify: boolean) =>
        ['bigcommerce', 'shopify', 'woocommerce'].includes(source.toLowerCase())
            ? null
            : <NavLink notify={notify} disabled={disabled} to="/update"><Text id="Containers.title"/></NavLink>;

    const trustBoxOnlyNavBar = ({ disabled, notify, source }: NavBarProps) =>
        <div>
            <NavLink to="/trustbox" disabled={disabled}><Text id="trustBox.title"/></NavLink>
            {renderFAQ(source, disabled)}
            {disabled && <NavLink notify={notify} disabled={disabled} to="/update"><Text id="Containers.title"/></NavLink>}
            <NavLink to="/settings" disabled={disabled}><Text id="settings.title"/></NavLink>
        </div>;

    const renderNavBarMode = () => {
        const { mode } = props;
        switch (mode) {
            case 'trustbox-only':
                return trustBoxOnlyNavBar(props);
            default:
                return defaultNavBar(props);
        }
    };

    return (
        <div>
           {renderNavBarMode()}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/CommonUI/UI/NavBar.tsx